'use client'

import type { CSSProperties } from 'react'
import type { FishingWorldActiveEvent } from '@/lib/fishing-world-scheduler'
import { createMicroLifePresentation } from '@/lib/fishing-world-anchors'
import { useAmbientEventCompletion } from './ambient-rendering'
import styles from './FishingScene.module.css'

interface AmbientNessieProps {
  event?: FishingWorldActiveEvent
  onComplete?: (eventId: string) => void
}

export function AmbientNessie({ event, onComplete }: AmbientNessieProps) {
  useAmbientEventCompletion(event, onComplete)
  if (!event) return null

  const placement = event.presentation?.placement ?? createMicroLifePresentation(event.kind, event.id)
  if (!placement) return null
  const position = {
    '--nessie-x': `${placement.center.x * 100}%`,
    '--nessie-y': `${placement.center.y * 100}%`,
    '--nessie-scale': placement.spriteScale,
  } as CSSProperties

  return (
    <div className={styles.nessieVisit} style={position} data-testid="ambient-nessie" aria-hidden="true">
      <i className={styles.nessieSprite} data-half="0" />
      <i className={styles.nessieSprite} data-half="1" />
      <span className={styles.nessieRipple}><i /><i /><i /></span>
    </div>
  )
}
